const CH2Analytics = require('./CH2Analytics');

class CH2Utilities {
    /**
     * the function get a string in input and replace the empty spaces and special characters with underscore _
     * For Unicode reference, visit: https://www.regular-expressions.info/unicode.html
     * @param {string} string - String to be updated
     * @returns {string} - Updated string
     */
    static updateString(string) {
        // eslint-disable-next-line no-undef-init
        let newString = undefined;
        if (string) {
            const europeanCh = 'A-Z0-9';
            const arabianCh = '\u0621-\u064A';
            const japaneseCh =
                '\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u2605-\u2606\u2190-\u2195\u203B';
            const chineseCh =
                '\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29\ud840-\ud868\udc00-\udfff\ud869\udc00-\uded6\udf00-\udfff\ud86a-\ud86c\udc00-\udfff\ud86d\udc00-\udf34\udf40-\udfff\ud86e\udc00-\udc1d';
            const koreanCh = '\uAC00-\uD7AF\u3130-\u318F\u1100-\u11FF';
            const russianCh = '\u0400-\u04FF';
            // Create regex excluding digit, number, arabic and japanese characters
            // eslint-disable-next-line no-misleading-character-class, prefer-template
            const regex = new RegExp('[^' + europeanCh + arabianCh + japaneseCh + chineseCh + koreanCh + russianCh + ']+', 'ig');
            newString = string.trim().replace(regex, '_').toLowerCase();
        }
        return newString;
    }

    /**
     * This function returns the value of a variable, if it is a valid nonempty string.
     * @param {string} _variable - The variable to check
     * @returns {string} - The string value, or null.
     */
    static safeStringValue(_variable) {
        if (typeof _variable === 'string' && _variable.trim().length > 0) {
            return _variable.trim();
        }
        return null;
    }

    /**
     * This function returns the value a safe font size number, starting from a string.
     * @param {string} _variable - The font size in a string variable
     * @returns {number} - The font size in numbers, or null.
     */
    static safeFontSizeNumber(_variable) {
        let _string = this.validStringValue(_variable);
        if (_string) {
            _string = _string.replaceAll('px', '');
            _string = _string.trim();
            if (_string !== '') {
                const number = Number(_string);
                if (!Number.isNaN(number)) {
                    return number;
                }
            }
        }
        return null;
    }

    /**
     * Reflow function
     * @param {canvas} _canvas - HTML Element Canvas with id: application-canvas
     * @param {app} _app - PlayCanvas "App" instance
     */
    static reflow(_canvas, _app) {
        if (!_canvas || !_app) {
            return;
        }
        // _canvas.width = '';
        // _canvas.height = '';
        const { width, height } = _canvas.getBoundingClientRect();
        _app.resizeCanvas(width, height);
    }

    /**
     * Open 3D Viewer
     * @param {canvas} _canvas - HTML Element Canvas with id: application-canvas
     * @param {app} _app - PlayCanvas "App" instance
     */
    static openButtonPressed(_canvas, _app) {
        // Add CSS
        console.log('openButtonPressed');
        this.reflow(_canvas, _app);
        /*
        $('body').on('player3d:open', function () {
            $('#player3d-modal').addClass('is-open');
            reflow();
        });
        */
    }

    /**
     * Close 3D Viewer
     * @param {isFullscreen} isFullscreen - If 3D Viewer is in Fullscreen mode.
     */
    static closeButtonPressed(isFullscreen) {
        this.triggerFullScreen(isFullscreen);
        // Add CSS To Close
        // Reset Configurator Form
        /*
        $('body').on('click', '#player3d-modal #close-player3d', function () {
            $('body').trigger('player3d:close');
        });
        $('body').on('player3d:close', function () {
            $('#player3d-modal').removeClass('is-open');
            // If 3d player was closed in fullscreen, revert it back to small
            if ($('#player3d-modal').hasClass('mode-viewer-full') || $('#player3d-modal').hasClass('mode-configurator-full')) {
                $('body').trigger('player3d:toggleViewMode', { mode: 'small' });
            }
            // Reset form configurator
            if ($('#ch2_btn-3dconfigurator').length > 0) {
                $('body').trigger('player3d:configurator:reset');
            }
        });
        */
    }

    /**
     * Open/Close 3D Viewer
     * @param {isFullscreen} isFullscreen - If 3D Viewer is in Fullscreen mode.
     * @param {HTML} _applicationLoadingContainer - If 3D Viewer is in Fullscreen mode.
     * @param {canvas} canvastmp - HTML Element Canvas with id: application-canvas
     * @param {app} apptmp - PlayCanvas "App" instance
     */
    static triggerFullScreen(
        isFullscreen,
        _applicationLoadingContainer,
        canvastmp,
        apptmp,
    ) {
        if (isFullscreen) {
            // Enter Full Screen
            _applicationLoadingContainer.classList.remove('mode-viewer-small');
            _applicationLoadingContainer.classList.add('mode-viewer-full');
        } else {
            // Exit Full Screen
            _applicationLoadingContainer.classList.remove('mode-viewer-full');
            _applicationLoadingContainer.classList.add('mode-viewer-small');
        }
        this.reflow(canvastmp, apptmp);
        /*
        // Fullscreen toggle event
        $('body').on('player3d:toggleViewMode', function (e, data) {
            const mode = data.mode;
            var modal = document.querySelector('#player3d-modal');
            if (mode === 'small') {
                $('body').removeClass('disable-scroll');
                modal.classList.add('mode-viewer-small');
                modal.classList.remove('mode-viewer-full');
                modal.classList.remove('mode-configurator-full');
                reflow();
            } else if (mode === 'full') {
                $('body').addClass('disable-scroll');
                modal.classList.add('mode-viewer-full');
                modal.classList.remove('mode-viewer-small');
                modal.classList.remove('mode-configurator-full');
                reflow();
            } else if (mode === 'configurator-full') {
                $('body').addClass('disable-scroll');
                modal.classList.add('mode-configurator-full');
                modal.classList.remove('mode-viewer-small');
                modal.classList.remove('mode-viewer-full');
                reflow();
            }
        });
        // Click on Fullscreen inside player 3D
        $('body').on('click', '.zoom-buttons-container button.fullscreen, .zoom-buttons-container button.exit-fullscreen', function () {
            var modal = document.querySelector('#player3d-modal');
            var isFullscreen = modal.classList.contains('mode-viewer-full');
            if (isFullscreen) {
                $('body').trigger('player3d:toggleViewMode', { mode: 'small' });
            } else {
                $('body').trigger('player3d:toggleViewMode', { mode: 'full' });
            }
        });
        */
    }

    loadModules_64(pc, modules, urlPrefix, doneCallback) {
        if (typeof modules === 'undefined' || modules.length === 0) {
            // caller may depend on callback behaviour being async
            setTimeout(doneCallback);
            return;
        }

        let remaining = modules.length;

        const moduleLoaded = () => {
            if (--remaining === 0) {
                doneCallback();
            }
        };

        modules.forEach(function (m) {
            pc.WasmModule.setConfig(m.moduleName, {
                glueUrl: urlPrefix + m.glueUrl,
                wasmUrl: urlPrefix + m.wasmUrl,
                fallbackUrl: urlPrefix + m.fallbackUrl,
            });

            if (!m.hasOwnProperty('preload') || m.preload) {
                if (m.moduleName === 'BASIS') {
                    // preload basis transcoder
                    pc.basisInitialize();
                    moduleLoaded();
                } else if (m.moduleName === 'DracoDecoderModule') {
                    // preload draco decoder
                    if (pc.dracoInitialize) {
                        // 1.63 onwards
                        pc.dracoInitialize();
                        moduleLoaded();
                    } else {
                        // 1.62 and earlier
                        pc.WasmModule.getInstance(m.moduleName, () => { moduleLoaded(); });
                    }
                } else {
                    // load remaining modules in global scope
                    pc.WasmModule.getInstance(m.moduleName, () => { moduleLoaded(); });
                }
            } else {
                moduleLoaded();
            }
        });
    }

    loadModules(modules, urlPrefix, doneCallback) {
        // check for wasm module support
        function wasmSupported() {
            try {
                if (
                    typeof WebAssembly === 'object' &&
                    typeof WebAssembly.instantiate === 'function'
                ) {
                    const module = new WebAssembly.Module(
                        Uint8Array.of(
                            0x0,
                            0x61,
                            0x73,
                            0x6d,
                            0x01,
                            0x00,
                            0x00,
                            0x00,
                        ),
                    );
                    if (module instanceof WebAssembly.Module) {
                        return (
                            new WebAssembly.Instance(module) instanceof
                            WebAssembly.Instance
                        );
                    }
                }
            } catch (e) {
                console.error('Change2 - Error WASM');
                if (!this.analytics) {
                    this.analytics = new CH2Analytics();
                    this.analytics.logBulgariError('Change2 - Error WASM');
                }
            }
            return false;
        }

        // load a script
        function loadScriptAsync(url) {
            const tag = document.createElement('script');
            tag.onload = function () {
                doneCallback();
            };
            tag.onerror = function () {
                throw new Error(`failed to load ${url}`);
            };
            tag.async = true;
            tag.src = url;
            tag.crossOrigin = 'anonymous';
            document.head.appendChild(tag);
        }

        // load and initialize a wasm module
        function loadWasmModuleAsync(moduleName, jsUrl, binaryUrl) {
            loadScriptAsync(jsUrl, function () {
                const lib = window[moduleName];
                window[`${moduleName}Lib`] = lib;
                lib({
                    locateFile: function () {
                        return binaryUrl;
                    },
                }).then(function (instance) {
                    window[moduleName] = instance;
                    doneCallback();
                });
            });
        }

        if (typeof modules === 'undefined' || modules.length === 0) {
            // caller may depend on callback behaviour being async
            setTimeout(doneCallback);
        } else {
            let asyncCounter = modules.length;
            const asyncCallback = function () {
                asyncCounter--;
                if (asyncCounter === 0) {
                    doneCallback();
                }
            };

            const wasm = wasmSupported();
            modules.forEach(function (m) {
                if (!m.hasOwnProperty('preload') || m.preload) {
                    if (wasm) {
                        loadWasmModuleAsync(
                            m.moduleName,
                            urlPrefix + m.glueUrl,
                            urlPrefix + m.wasmUrl,
                        );
                    } else {
                        if (!m.fallbackUrl) {
                            throw new Error(
                                `wasm not supported and no fallback supplied for module ${m.moduleName}`,
                            );
                        }
                        loadWasmModuleAsync(
                            m.moduleName,
                            urlPrefix + m.fallbackUrl,
                            '',
                        );
                    }
                } else {
                    asyncCallback();
                }
            });
        }
    }

    isMobile(_navigator) {
        if (
            _navigator.userAgent.match(/Android/i) ||
            _navigator.userAgent.match(/webOS/i) ||
            _navigator.userAgent.match(/iPhone/i) ||
            _navigator.userAgent.match(/iPad/i) ||
            _navigator.userAgent.match(/iPod/i) ||
            _navigator.userAgent.match(/BlackBerry/i) ||
            _navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        }
        return false;
    }

    deviceType(_navigator, _window) {
        let deviceName = 'undefined';
        //
        if (/android/i.test(_navigator.userAgent)) {
            deviceName = 'android';
        } else if (
            (/iPad|iPhone|iPod/.test(_navigator.userAgent) &&
                !_window.MSStream) ||
            (_navigator.platform === 'MacIntel' &&
                _navigator.maxTouchPoints > 1)
        ) {
            deviceName = 'iOS';
        } else if (/CriOS\//.test(_navigator.userAgent)) {
            deviceName = 'criOS';
        }
        //
        if (/Safari\//.test(_navigator.userAgent)) {
            return 'safari';
        }
        if (/firefox/i.test(_navigator.userAgent)) {
            return 'firefox';
        }
        if (/OculusBrowser/i.test(_navigator.userAgent)) {
            return 'oculus';
        }
        if (_window.webkit && _window.webkit.messageHandlers) {
            return 'wkkit';
        }
        return deviceName;
    }

    static isAndroid() {
        return /android/i.test(navigator.userAgent);
    }

    static isIos() {
        // iOS
        return (
            (/iPad|iPhone|iPod/.test(navigator.userAgent) &&
                !window.MSStream) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        );
    }

    static isSafari() {
        return /Safari\//.test(navigator.userAgent);
    }

    static isFirefox() {
        return /firefox/i.test(navigator.userAgent);
    }

    static isOculus() {
        return /OculusBrowser/i.test(navigator.userAgent);
    }

    static isIosChrome() {
        // iOS
        return this.isIos() && /CriOS\//.test(navigator.userAgent);
    }

    static isIosSafari() {
        // iOS
        return this.isIos() && this.isIosSafari();
    }

    static isWkWebView() {
        return window.webkit && window.webkit.messageHandlers;
    }

    static isSupportsSceneViewer() {
        // --> isSceneViewerSupported()
        return this.isAndroid() && !this.isFirefox() && !this.isOculus();
    }

    static isSupportsQuickLook() {
        // --> isQuickLookSupported()
        if (!this.isIos()) {
            return false;
        }
        if (!this.isWkWebView()) {
            const tempAnchor = document.createElement('a');
            return (
                tempAnchor.relList &&
                tempAnchor.relList.supports &&
                tempAnchor.relList.supports('ar')
            );
        }
        return Boolean(
            /CriOS\/|EdgiOS\/|FxiOS\/|GSA\/|DuckDuckGo\//.test(
                navigator.userAgent,
            ),
        );
    }
    // static isSupportsSceneViewer() {
    //     if (this.isAndroid() && !this.isFirefox() && !this.isOculus()) {
    //         return true;
    //     }
    //     return false;
    // }
}

module.exports = CH2Utilities;
